
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexJuzz_6VOMQpzVwc_eWTyowir5Hu3RO8U2kqfq7fp7VMMeta } from "/home/snaumann/Development/public_html/firmenlauf-potsdam/public/app/pages/index.vue?macro=true";
import { default as kontakt1uAya_SIQyawP2z3geohw6484mwz07K94CRVocq9h38Meta } from "/home/snaumann/Development/public_html/firmenlauf-potsdam/public/app/pages/kontakt.vue?macro=true";
import { default as _91article_slug_93BBYXyaPcqDJbcq0z_3hQgy_hXzwr2K7P5RcnpPtufOQMeta } from "/home/snaumann/Development/public_html/firmenlauf-potsdam/public/app/pages/[article_slug].vue?macro=true";
import { default as indexgpV1MOhhw4QahCtyI_iDDOEtY_JyjPjCBeFHKSE_UlMMeta } from "/home/snaumann/Development/public_html/firmenlauf-potsdam/public/app/pages/alles-zum-lauf/index.vue?macro=true";
export default [
  {
    name: "home",
    path: "/",
    component: () => import("/home/snaumann/Development/public_html/firmenlauf-potsdam/public/app/pages/index.vue")
  },
  {
    name: "contact",
    path: "/kontakt",
    component: () => import("/home/snaumann/Development/public_html/firmenlauf-potsdam/public/app/pages/kontakt.vue")
  },
  {
    name: "article-detail",
    path: "/:article_slug()",
    component: () => import("/home/snaumann/Development/public_html/firmenlauf-potsdam/public/app/pages/[article_slug].vue")
  },
  {
    name: "run-detail",
    path: "/alles-zum-lauf",
    component: () => import("/home/snaumann/Development/public_html/firmenlauf-potsdam/public/app/pages/alles-zum-lauf/index.vue")
  }
]